module.exports = "<a [routerLink]=\"['/']\"> <img src=\"assets/images/brtim-logo.png\"  alt=\"\"> </a>\r\n"